<template>
    <div class="flat-mail-input" id="flat-mail-input" v-if="form != null">
        <form class="form-in" v-if="formVisible" @submit="sendDataSubmit">
            <div class="form-group">
                <input type="email" name="email" class="form-control"  autocomplete="off" placeholder="E-mail" v-model="email" v-validate="{rules: { required: true, regex: regexRules.email }}">
            </div>
            <div class="btn-send">
                <button class="btn-submit btn-success" type="button" @click="sendFlatMail" :disabled="errors.any()">
                    <svg-icon icon-class="plane" className="icon-plane"/>
                </button>
            </div>
        </form>
        <div class="successMessage" v-else>
            <h3>отправлено</h3>
        </div>
    </div>
</template>

<script>
    import { Validator } from 'vee-validate';
    const dict = {
        custom: {
            email: {
                required: () => 'Введите ваш E-mail'
            }
        }
    };
    Validator.localize('ru', dict);
    export default {
        name: 'formMail',
        props: ['options'],
        data () {
            return {
                formVisible: true,
                email: '',
                regexRules: {
                    email: /[a-zA-Z0-9_\.\+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-\.]+/
                }
            }
        },
        components: {
        },
        computed: {
            form () {
                return this.$store.state.forms
            }
        },
        methods: {
            sendFlatMail() {
                var querystring = require('querystring');
                var data = {
                    'pdf': this.options[0].pdf,
                    'name': this.options[0].name,
                    'mail': this.email
                };
                this.$validator.validate().then(result => {
                    if(result) {
                        this.formVisible = false
                        // console.log(data);
                        axios.post('/formFlat.php',querystring.stringify(data));
                    } else {
                        console.log('Form Send mail with errors');
                    }
                });
            },
            sendDataSubmit(e) {
                e.preventDefault();
                var querystring = require('querystring');
                var data = {
                    'pdf': this.options[0].pdf,
                    'name': this.options[0].name,
                    'mail': this.email
                };
                this.$validator.validate().then(result => {
                    if(result) {
                        this.formVisible = false
                        // console.log(data);
                        axios.post('/formFlat.php',querystring.stringify(data));
                    } else {
                        console.log('Form Send mail with errors');
                    }
                });
            }
        },
        mounted () {
            // this.$store.watch(
            //     (state) => state.forms,
            //     (newValue) => {
            //         if (newValue)
            //         this.resetErros();
            //     }
            // )
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/forms/form-mail.scss';
    @import '@/styles/components/forms/forms-respond/form-mail-respond.scss';
</style>